import { SimpleMediaDto } from "../tasks/taskDetail/interface";

export type ClientType = "BUYER" | "SELLER" | "BOTH";

export interface ExporterUserSignInRequestBody {
  aId: string;
  password: string;
}

export interface ExporterUserDto {
  // 데이터 ID(PK)
  id: number;
  // 생성 일시
  createdAt: string;
  // 수정 일시
  updatedAt: string;
  // 삭제 일시
  deletedAt: string;
  // 계정 객체
  account: AccountDto;
  // 수출회사 객체
  exporter: ExporterDto;
  // 유저 타입
  exporterUserType: ExporterUserType;
  // 이름
  name: string;
  // 아이디(이메일과 동일)
  aId: string;
  // 이메일
  email: string;
  // 메인 카테고리 공통코드 아이템 codeItemName 배열
  mainCategoryCodeItemNames: string[];
  // 담당 유형, 일반 직원의 경우 수입/수출 중 일부를 담당할 수도 있다
  exporterUserMainFieldType: ClientType;
  // 사무실 연락처
  officeContact?: string;
  // 사무실 연락처 prefix(국가 번호)
  officeContactPrefix?: string;
  // 개인 연락처
  personalContact?: string;
  // 개인 연락처 prefix(국가 번호)
  personalContactPrefix?: string;
  // 회원 탈퇴 사유
  withdrawalReason?: string;
  // isActivated 최신 변경일자
  isActivatedChangedAt?: string;
  // 가입 경로
  joinPath?: SignupJoinPathType;
  // 가입 경로 etc인 경우 기타 사유.
  joinPathDescription?: string;
  // 유저 구독 활성화 여부
  isSubscriptionActivated: boolean;
  // companyName;
  companyName: string;
  // telPrefix;
  telPrefix: string;
  // tel;
  tel: string;
  // fax
  fax: string;
  countryName: string;
  // faxPrefix;
  faxPrefix: string;
  region: string;
  postalCode: string;
  locality: string;
  streetAddress: string;
  // 언어설정
  language?: string;
}

export interface CorporationSignUpRequestBody {
  businessNumber: string;
  companyName: string;
  telPrefix: string;
  tel: string;
  faxPrefix: string;
  fax?: string;
  countryName: string;
  region?: string;
  locality?: string;
  streetAddress?: string;
  postalCode?: string;
  countryCodeItemName: string;
  industryCodeItemNames: string[];
  mainCategoryCodeItemNames: string[];
  authTokenId: string;
  verifyString: string;
  name: string;
  aId: string;
  isMarketingEmailReceive: boolean;
  password: string;
  optionalTermsHistoryIdList: number[];
  city: string;
  gmtOffset: number;
}

export type SignupJoinPathType =
  | "SEARCHING"
  | "REFERRAL"
  | "NEWS_ARTICLE"
  | "EXHIBITION"
  | "ETC";

export interface ManagerSignUpDto {
  // 데이터 ID(PK, uuid)
  authTokenId: string;
  // 이메일 혹은 휴대폰 번호로 전달받는 인증번호(DB 저장 시 hash)
  verifyString: string;
  // 이름
  name: string;
  // 아이디(이메일과 동일)
  aId: string;
  // 마케팅 이메일 수신 동의 여부
  isMarketingEmailReceive: boolean;
  // 비밀번호
  password: string;
  // 수출회사 ID(PK)
  exporterId: number;
  // 메인 카테고리 공통코드 아이템 codeItemName 배열
  mainCategoryCodeItemNames: string[];
  // 선택 약관 이력의 ID(PK)
  optionalTermsHistoryIdList: number[];
  // 담당 유형, 일반 직원의 경우 수입/수출 중 일부를 담당할 수도 있다
  exporterUserMainFieldType: ClientType;
  // 개인 연락처 prefix(국가 번호)
  personalContactPrefix?: string;
  // 개인 연락처
  personalContact?: string;
  // 사무실 연락처 prefix(국가 번호)
  officeContactPrefix?: string;
  // 사무실 연락처
  officeContact?: string;

  // 가입 경로
  joinPath?: SignupJoinPathType;
  // 가입 경로 etc인 경우 기타 사유.
  joinPathDescription?: string;
}

export interface JoinExistingCompanyDto {
  // 수출회사 ID(PK)
  exporterId: number;
  // 메인 카테고리 공통코드 아이템 codeItemName 배열
  mainCategoryCodeItemNames: string[];
  // 담당 유형, 일반 직원의 경우 수입/수출 중 일부를 담당할 수도 있다
  exporterUserMainFieldType: ClientType;
}

export interface CreateCompanyForAccountDto {
  businessNumber: string;
  companyName: string;
  companyType: ClientType;
  telPrefix: string;
  tel: string;
  faxPrefix?: string;
  fax?: string;
  countryName: string;
  region?: string;
  locality?: string;
  streetAddress?: string;
  postalCode?: string;
  countryCodeItemName: string;
  industryCodeItemNames: string[];
  mainCategoryCodeItemNames: string[];
  gmtOffset: number;
  city: string;
  personalContactPrefix?: string;
  personalContact?: string;
  joinPath?: SignupJoinPathType;
  joinPathDescription?: string;
}

export interface AccountDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  password?: string;
  isTemporaryPassword: boolean;
  signInFailCount: number;
  passwordChangedAt: string;
  passwordChangePendedAt: string;
  requiredTermsAgreedAt: string;
  lockedAt?: string;
  isActivated: boolean;
  isMarketingEmailReceive: boolean;
  notificationEmailReceive: boolean;
  notificationSmsReceive: boolean;
  notificationWebPushReceive: boolean;
  isMfaOn: boolean;
  language?: string;
  service?: string;
  timezone?: string;
  email?: string | null;
  name?: string | null;
  personalContactPrefix?: string | null;
  personalContact?: string | null;
  faxPrefix?: string | null;
  fax?: string | null;
  isSignupCompleted?: boolean;
}

export interface ExporterDto {
  // 데이터 ID(PK)
  id: number;
  // 생성 일시
  createdAt: string;
  // 수정 일시
  updatedAt: string;
  // 삭제 일시
  deletedAt: string;
  // 사업자등록번���
  businessNumber: string;
  // 회사명
  companyName: string;
  // 회사코드
  companyCode: string;
  // 전화번호 prefix(국가 번호)
  telPrefix: string;
  // 전화번호
  tel: string;
  // 팩스 prefix(국가 번호)
  faxPrefix: string;
  // 팩스
  fax: string;
  // example: 대한민국
  countryName: string;
  country: string;
  // example: 서울특별시
  region: string;
  // example: 마포구
  locality: string;
  // example: 합정동 359-2
  streetAddress: string;
  // example: 121-220
  postalCode: string;
  // 국가 공통코드 아이템 codeItemName example: KR
  countryCodeItemName: string;
  // 산업군 공통코드 아이템 codeItemName 배열
  industryCodeItemNames: string[];
  // 메인 카테고리 공통코드 아이템 codeItemName 배열
  mainCategoryCodeItemNames: string[];
  isActivated: boolean;
  initialApprovalAt?: string;
  // 신규 직원 자동 승인 여부
  autoApproveNewMembers?: boolean;
  // 회사연동코드
  companyLinkCode: string;
  // 기업 유형
  companyType: ClientType;
  // 은행명
  bankName?: string;
  // bankCountryName. (placeholder)Country/Region
  bankCountryName?: string;
  // bankRegion. (placeholder)State/Province
  bankRegion?: string;
  // bankLocality. (placeholder)City
  bankLocality?: string;
  // bankStreetAddress. (placeholder)Apartment, Unit, Suite, or Floor #(Optional)
  bankStreetAddress?: string;
  // bankPostalCode. (placeholder)Postal Code
  bankPostalCode?: string;
  // 은행 전화번호 prefix(국가 번호)
  bankTelPrefix?: string;
  // 은행 전화번호
  bankTel?: string;
  // 은행 팩스 prefix(국가 번호)
  bankFaxPrefix?: string;
  // 은행 팩스
  bankFax?: string;
  // Swift Code
  swiftCode?: string;
  // 계좌번호
  accountNumber?: string;
  // 계좌명
  accountName?: string;
  // 무료기간 사용일시
  freeSubscriptionTrialUsedAt: string | null;
  // 회사 로고
  businessLogoMedia?: SimpleMediaDto;
  // GMT 시간대
  gmtOffset: number;
}

export interface ExportersInfoRequestParams {
  companyCode?: string;
  page?: number;
  pageSize?: number;
}

export interface AuthTokenIdRequestBody {
  contact: string;
  usage: string;
}

export interface AuthTokenIdDto {
  authTokenId: string;
}

export interface ChangeExporterUserPasswordDto {
  aId: string;
  password: string;
  oldPassword: string;
}

export type ExporterUserType =
  | "CORPORATE_MANAGER"
  | "MIDDLE_MANAGER"
  | "MANAGER";

export interface ModifyExporterUserBySessionDto {
  // 개인 연락처 prefix(국가 번호)
  personalContactPrefix?: string | null;
  // 개인 연락처
  personalContact?: string | null;
  // 사무실 연락처 prefix(국가 번호)
  officeContactPrefix?: string | null;
  // 사무실 연���처
  officeContact?: string | null;
  // 마케팅 이메일 수신 동의 여부
  isMarketingEmailReceive?: boolean;
  // 이메일 알림 수신 동의 여부
  notificationEmailReceive?: boolean;
  // SMS 알림 수신 동의 여부
  notificationSmsReceive?: boolean;
  // 웹푸시 알림 수신 동의 여부
  notificationWebPushReceive?: boolean;
  // 다중 인증 활성화 여부
  isMfaOn?: boolean;
  // 언어설정
  language?: string;
}

export interface ChangeExporterUserPasswordBySessionDto {
  // 변경할 새로운 비밀번호
  password: string;
  // 기존 비밀번호
  oldPassword: string;
}

export interface WithdrawalReasonDto {
  // 회원 탈퇴 사유
  withdrawalReason: string;
}

export interface MfaDto {
  // 인증에 성공한 경우 만들어지는 authToken
  authToken: string;
  // 마스킹 처리된 이메일
  maskedEmail: string;
  // 마스킹 처리된 개인 연락처
  maskedPersonalContact: string | null;
}

export interface GenerateAuthTokenForMfaDto {
  // 인증 수단
  contactType: "EMAIL" | "PHONE";
  // 인증에 성공한 경우 만들어지는 authToken
  authToken: string;
}

export interface AuthTokenIdDto {
  authTokenId: string;
}

export interface ExporterUserMfaSignInDto {
  // 데이터 ID(PK, uuid)
  authTokenId: string;
  // 이메일 혹은 휴대폰 번호로 전달받는 인증번호(DB 저장 시 hash)
  verifyString: string;
  // 인증에 성공한 경우 만들어지는 authToken
  authToken: string;
}

export interface CorporateManagerSignUpDto {
  // 사업자등록번호;
  businessNumber: string;
  // 회사명
  companyName: string;
  // 기업 유형
  companyType: ClientType;
  // 전화번호 prefix(국가 번호)
  telPrefix: string;
  // 전화번호
  tel: string;
  // 팩스 prefix(국가 번호)
  faxPrefix?: string;
  // 팩스
  fax?: string;
  // countryName. example: 대한민국
  countryName: string;
  // region. (placeholder)State/Province example: 서울특별시
  region?: string;
  // locality. (placeholder)City example: 마포구
  locality?: string;
  // streetAddress. (placeholder)Apartment, Unit, Suite, or Floor #(Optional) example: 합정동 359-2
  streetAddress?: string;
  // postalCode. (placeholder)Postal Code example: 121-220
  postalCode?: string;
  // 국가 공통코드 아이템 codeItemName ex: "KR"
  countryCodeItemName: string;
  // 산업군 공통코드 아이템 codeItemName 배열
  industryCodeItemNames: string[];
  // 메인 카테고리 공통코드 아이템 codeItemName 배열
  mainCategoryCodeItemNames: string[];
  // 이름
  name: string;
  // 아이디(이메일과 동일)
  aId: string;
  // 마케팅 이메일 수신 동의 여부
  isMarketingEmailReceive: boolean;
  // 비밀번호
  password: string;
  // 선택 약관 이력의 ID(PK)
  optionalTermsHistoryIdList: number[];
  // 도시
  city: string;
  // GMT 시간대
  gmtOffset: number;
  // 인증 토큰 ID (이메일 인증에 사용)
  authTokenId: string;
  // 개인 연락처 prefix(국가 번호)
  personalContactPrefix?: string;
  // 개인 연락처
  personalContact?: string;
  // 가입 경로
  joinPath?: SignupJoinPathType;
  // 가입 경로 etc인 경우 기타 사유
  joinPathDescription?: string;
}

export interface AuthTokenIdVerifyStringDto {
  // 데이터 ID(PK, uuid)
  authTokenId: string;
  // 이메일 혹은 휴대폰 번호로 전달받는 인증번호(DB 저장 시 hash)
  verifyString: string;
}

export interface AuthTokenVerifiedDto {
  // 인증에 성공한 경우 만들어지는 authToken
  authToken: string;
}

export interface ExporterUserAdditionalInfoDto {
  // ExporterUser의 ID(PK). PrimaryColumn의 역할을 함
  exporterUserId: number;
  // 웹 서비스 최초 이용 가이드 필요 여부
  isInitialGuideNeeded?: boolean;
  // 퀵스타트 가이드 필요 여부(수출자)
  exportQuickStartGuideNeeded?: boolean;
  // 퀵스타트 가이드 필요 여부(수입자)
  importQuickStartGuideNeeded?: boolean;
}

export interface ModifyExporterUserAdditionalInfoDto {
  // 웹 서비스 최초 이용 가이드 필요 여부
  isInitialGuideNeeded?: boolean;
  // 퀵스타트 가이드 필요 여부(수출자)
  exportQuickStartGuideNeeded?: boolean;
  // 퀵스타트 가이드 필요 여부(수입자)
  importQuickStartGuideNeeded?: boolean;
}

export interface EmailDomainCheckRequestDto {
  email: string;
}

export enum EmailStatus {
  AVAILABLE = "AVAILABLE",
  IN_USE = "IN_USE",
  SIGNUP_IN_PROGRESS = "SIGNUP_IN_PROGRESS",
}

export interface EmailDomainCheckResponseDto {
  emailStatus: EmailStatus;
  message?: string;
  canLogin?: boolean;
  account?: AccountDto;
  companyExists?: boolean;
  exporter?: ExporterDto;
}

export interface IndividualSignUpRequestDto {
  email: string;
  password: string;
  name: string;
  personalContactPrefix?: string;
  personalContact?: string;
  requiredTermsIdList: number[];
  optionalTermsHistoryIdList: number[];
  isMarketingEmailReceive: boolean;
}

export interface AccountSignInResponseDto {
  accountDto: AccountDto;
  accessToken: string;
  hasExporterUser: false;
  companyExists: boolean;
  exporter?: ExporterDto;
}

export interface RequestCompanyCodeDto {
  companyName: string;
  employeeEmail: string;
  employeeName: string;  // Required field - backend validation
}
